import { useMemo, useCallback, useState } from 'react';

import { useNotifications } from '../../../../../hooks/useNotifications';
import { useDebouncedFunction } from '../../../../../hooks/useDebouncedFunction';

// clean value to support previous versions
const cleanDefaultValue = (defaultValue) => {
  if (!Array.isArray(defaultValue)) return [];
  const checkedNodes = defaultValue.filter((item) => {
    if (!item.nodes?.length) return item.checked;
    return cleanDefaultValue(item.nodes).length;
  });
  return checkedNodes;
};

export const useCustomListField = ({ listId, defaultValue, getRoot }) => {
  const [listRootData, setListRootData] = useState({ id: listId, title: '' });
  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = useState(cleanDefaultValue(defaultValue));

  const { showErrorNotification } = useNotifications();

  const legacyValue = useMemo(() => {
    const getValues = (items, parents = [], values = []) => {
      for (const item of items) {
        if (!item.nodes?.length) {
          values.push([...parents, item.title]);
        } else {
          getValues(item.nodes, [...parents, item.title], values);
        }
      }
      return values;
    };
    return getValues(value);
  }, [value]);

  const getListRoot = useCallback(async () => {
    setIsLoading(true);
    try {
      const { listRoot } = await getRoot(listId);
      setListRootData({
        id: listRoot.id,
        title: listRoot.title,
      });
    } catch (error) {
      showErrorNotification({
        title: 'error',
        description: 'errorRetrievingRecord',
      });
    } finally {
      setIsLoading(false);
    }
  }, [listId, showErrorNotification, getRoot]);

  useDebouncedFunction(getListRoot, 100);

  return {
    isLoading,
    listRoot: listRootData,
    value,
    setValue,
    legacyValue,
  };
};
